import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { IS_DEV } from "./variables";

i18n
	.use(HttpApi)
	.use(LanguageDetector)
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		returnNull: false,
		backend: {
			loadPath: "/locales/{{lng}}.json",
		},
		lng: "no-NB", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
		// you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
		// if you're using a language detector, do not define the lng option
		fallbackLng: ["no-NB", "no-NY", "en"],
		debug: IS_DEV,
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
	});

export default i18n;
